export const getJaneUserId = (user = null) => {
    const candidates = [user?.user_id, user?.id];
    for (const candidate of candidates) {
        const userId = Number(candidate);
        if (Number.isInteger(userId) && userId > 0) return userId;
    }
    return null;
};

